// router/Router.tsx
import React, { Suspense, useMemo } from "react";
import {
	BrowserRouter as Router,
	Routes,
	Route,
	Navigate,
} from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "store/store";

import { routesConfig } from "./routesConfig";
import LayoutWrapper from "@components/Layout/LayoutWrapper";
import LoadingSpinner from "@components/LoadingSpinner";
import { PrivateRoute } from "./PrivateRoute";

const AppRouter: React.FC = () => {
	const isUserAuthenticated = useSelector(
		(state: RootState) => state.auth.isAuthenticated,
	);

	const firstPublicPath = useMemo(
		() => routesConfig.find((r) => r.type === "public")?.path || "/",
		[],
	);
	const firstPrivatePath = useMemo(
		() => routesConfig.find((r) => r.type === "private")?.path || "/",
		[],
	);

	return (
		<Router>
			<Suspense fallback={<LoadingSpinner />}>
				<Routes>
					{routesConfig.map(
						({ path, component: Component, type, layoutType }) => {
							const pageEl = (
								<LayoutWrapper layoutType={layoutType}>
									<Component />
								</LayoutWrapper>
							);

							return (
								<Route
									key={path}
									path={path}
									element={
										type === "private" ? (
											<PrivateRoute isAuthenticated={isUserAuthenticated}>
												{pageEl}
											</PrivateRoute>
										) : (
											pageEl
										)
									}
								/>
							);
						},
					)}

					<Route
						path="*"
						element={
							<Navigate
								to={isUserAuthenticated ? firstPrivatePath : firstPublicPath}
								replace
							/>
						}
					/>
				</Routes>
			</Suspense>
		</Router>
	);
};

export default AppRouter;
